import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { useDismissMySharedContent } from 'actions/content';
export function useDismissShare(id) {
  var shareIds = id.toString().split('#');
  var shareRefId = shareIds.length === 2 ? shareIds[1] : shareIds[0];
  var shareContextId = shareIds.length === 2 ? shareIds[0] : null;
  var _useDismissMySharedCo = useDismissMySharedContent({
      shareRefId: shareRefId,
      shareContextId: shareContextId
    }),
    dismissShare = _useDismissMySharedCo.dismissShare;
  return {
    dismissShare: dismissShare
  };
}